/**
 * External dependencies
 */
import { css } from 'emotion';

export const Elevation = css`
	background: transparent;
	display: block;
	margin: 0 !important;
	pointer-events: none;
	position: absolute;
	will-change: box-shadow;
`;
